export class VerifyDocsAction {
  static readonly type = '[VerifyDocs] Add item';
  constructor(public payload: string) { }
}


export class GetApplicantList {
  static readonly type = '[VerifyDocs] Get Applicant List';
  constructor(public payload: {examId: string, drawId: string}) { }
}
